import { TableRow, TableCell, Button, IconButton } from "@mui/material";
import { useState } from "react";
import { Program, ProgramUser } from "../model/program"
import { AlertView } from "./alert";

import RemoveIcon from '@mui/icons-material/Remove';
import { getApiAccessToken } from "../auth/auth";
import { useMsal } from "@azure/msal-react";
import { AxiosError } from "axios";
import { useDispatch } from "react-redux";
import { removeUserFromProgramAsync } from "../reducers/userSlice";
import { AppDispatch } from "../reducers/store";

export interface ProgramUserRowProps {
    user: ProgramUser
    program: Program | null
}

export const ProgramUserRowView = (props: ProgramUserRowProps) => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const dispatch: AppDispatch = useDispatch();

    const [errorMessage, setError] = useState<string | null>(null);
    const [disabled, setDisabled] = useState<boolean>(false);
    
    const handleRemoveUserFromProgram = async (user: ProgramUser, program: Program | null) => {
        if (program == null) {
            console.log("program is malformed or missing")
            return;
        }

        try {
            setDisabled(true)
            let accessToken: string = await getApiAccessToken(instance, activeAccount)
            await dispatch(removeUserFromProgramAsync({accessToken: accessToken, userId: user.userId, programId: program.id}))
        } catch (error) {
            if (error instanceof AxiosError) {
                console.log(error)
                setError(error?.message)
            } else if (error instanceof Error) {
                console.error(error);
            }
        }
        
        setDisabled(false)
    };

    return(
        <>
            <AlertView error={errorMessage}/>
            <TableRow key={props.user.userId} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell sx={{ width: '40%', paddingLeft: '100px'}}>{props.user.email}</TableCell>
                <TableCell >
                    <Button
                        variant="outlined"
                        color="primary"
                        disabled={disabled}
                        onClick={() => handleRemoveUserFromProgram(props.user, props.program)}
                        sx={{
                            borderRadius: '8px',
                            maxWidth: '20px',
                        }}
                    >
                        <RemoveIcon sx={{ maxWidth: '20px' }}/>
                    </Button>
                </TableCell>
            </TableRow>
        </>
    )
}